/** Fallback for a section whose component threw at render time (caught by ErrorBoundary). */
import { fallbackStyle } from './fallbackStyle'

export function BrokenSection({
  sectionId,
  error,
}: {
  readonly sectionId: string
  readonly error: Error
}) {
  return (
    <div data-builder-fallback="broken-section" data-section-id={sectionId} style={fallbackStyle}>
      This section could not be rendered.
      {import.meta.env?.DEV ? <span> ({error.message})</span> : null}
    </div>
  )
}
